import React from 'react';
import PropTypes from 'prop-types';
import * as S from './styles';

var NavCollapseTrigger = function NavCollapseTrigger(_ref) {
  var collapsed = _ref.collapsed,
      onClick = _ref.onClick;
  return React.createElement(S.NavCollapseTriggerWrapper, null, React.createElement(S.NavCollapseTrigger, {
    collapsed: collapsed,
    onClick: onClick
  }, React.createElement(S.NavCollapseTriggerIcon, {
    type: "arrow-left",
    size: "xs"
  })));
};

NavCollapseTrigger.propTypes = {
  collapsed: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired
};
export default NavCollapseTrigger;